import * as StageStatus from '../stageStatus';
import LayerGroup from '../interaction/layerGroup/index';
import CabinetTransfer from '../interaction/cabinetTransfer';
import { updateCodiSystem } from './updateCodiSystem';
import { doneAsync } from './done';

// 内部调用函数均做了防抖处理
function updateEnd(): void {
    // 更新坐标系统
    updateCodiSystem();
    doneAsync();

    // 层板编组状态更新
    !StageStatus.isTopFace() && LayerGroup.updateLayerGroupStatus();

    // 卧柜穿梭布局更新
    StageStatus.isTopFace() && CabinetTransfer.updateAsync();
}

export {
    updateEnd
};
